import { Sidebar } from "../../shared/components";
import { AuthGuard } from "../../shared/guards/AuthGuard";
import { SignaturePresentation } from "./components/SignaturePresentation";

export const SignaturePage = (): JSX.Element => {
	return (
		<AuthGuard>
			<Sidebar>
				<SignaturePresentation />
			</Sidebar>
		</AuthGuard>
	);
};
